/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCellSignal1 = createReactComponent("outline", "cell-signal-1", "IconCellSignal1", [["path", { "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z", "key": "svg-0" }]]);

export { IconCellSignal1 as default };
//# sourceMappingURL=IconCellSignal1.mjs.map
